import * as React from 'react';
import Box from '@mui/material/Box';
import { AuthenticatedUser } from '../../../../../../../shared/types';
import { ArchivedOrderNotice } from '../../../shared/archiving/view/ArchivedOrderNotice';
import { IOrderRow } from '../../../Entities';
import { ImageEditorCommentsSection } from '../../comments/view/ImageEditorCommentsSection';
import { DoneEditingSection } from '../../doneEditing/view/DoneEditingSection';
import { ImageListTabs } from '../../listImages/view/ImageListTabs';
import { ImageEditorPhotoStatus } from '../queries/use-query-photo-status';
import {
    ImageProcessingStatus,
    useImageEditorImageProcessingData
} from '../state/use-image-editor-image-processing-data';
import { ImageEditorImageProcessingPageSkeleton } from './ImageEditorImageProcessingPageSkeleton';

type ImageEditorImageProcessingPageProps = {
    orderId: number;
    user: AuthenticatedUser;
    photoStatus: ImageEditorPhotoStatus;
    uneditedOrderRows: IOrderRow[] | null;
    editedOrderRows: IOrderRow[];
    editedOrderRowsUpdatedAt: number;
};

type ExternalProps = {
    user: AuthenticatedUser;
    orderId: number;
};

function ImageEditorImageProcessingPage({
    orderId,
    user,
    photoStatus,
    uneditedOrderRows,
    editedOrderRows,
    editedOrderRowsUpdatedAt
}: ImageEditorImageProcessingPageProps) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <ImageEditorCommentsSection orderId={orderId} user={user} />
            <DoneEditingSection
                orderId={orderId}
                user={user}
                photoStatus={photoStatus}
                editedOrderRows={editedOrderRows}
            />
            <ImageListTabs
                orderId={orderId}
                user={user}
                photoStatus={photoStatus}
                uneditedOrderRows={uneditedOrderRows}
                editedOrderRows={editedOrderRows}
                editedOrderRowsUpdatedAt={editedOrderRowsUpdatedAt}
            />
        </Box>
    );
}

export default function DataLayer({ user, orderId }: ExternalProps) {
    let data = useImageEditorImageProcessingData({ orderId, user });

    if (data.status === ImageProcessingStatus.Loading) {
        return <ImageEditorImageProcessingPageSkeleton user={user} />;
    }

    if (data.status === ImageProcessingStatus.Archived) {
        return <ArchivedOrderNotice onSubmit={data.onRetrieve} />;
    }

    return (
        <ImageEditorImageProcessingPage
            orderId={orderId}
            user={user}
            photoStatus={data.photoStatus}
            uneditedOrderRows={data.uneditedOrderRows}
            editedOrderRows={data.editedOrderRows}
            editedOrderRowsUpdatedAt={data.editedOrderRowsUpdatedAt}
        />
    );
}
